import { DocumentModel, DocumentTreeNodeModel, DocumentationTypeEnum } from './models/documentheque.model';
import { DocumenthequeApiResponse } from './models/api/documentheque.apiresponse';

const documentDateOptions: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
};

export class DocumenthequeProjector {

  public static projectDocuments(documentsResponse: DocumenthequeApiResponse.Documentation[]): DocumentModel[] {
    return documentsResponse.map(documentResp => {

      const createdAt = new Date(documentResp.createdAt);
      let document: DocumentModel = {
        nom: documentResp.nom,
        fileName: documentResp.fileName != null ? documentResp.fileName : documentResp.nom + documentResp.extension,
        description: documentResp.description,
        documentationId: documentResp.documentationId,
        createdAt: createdAt,
        createdAtString: createdAt.toLocaleDateString(undefined, documentDateOptions),
        isDownloading: false,
        type: this.projectDocumentType(documentResp.type)
      };

      return document;
    });
  }

  private static projectDocumentType(docType: string): DocumentationTypeEnum {
    return DocumentationTypeEnum[docType];
  }


  public static projectDocumentTree(documents: DocumentModel[]): DocumentTreeNodeModel[] {

    //aggregate documents by folder, a folder is repeated in the name of the document, separated by a / or \
    const folders: { [key: string]: DocumentTreeNodeModel } = {};
    const documentsTree: DocumentTreeNodeModel[] = [];

    //sort by date descending
    documents.sort((a, b) => (+b.createdAt - +a.createdAt));// convert date object into number to resolve issue in typescript

    documents.forEach(document => {
      const folderPath = document.nom.split(/\\|\//).slice(0, -1).join('/');
      const fileName = document.nom.split(/\\|\//).pop() || '';

      if (folderPath) {
        if (!folders[folderPath]) {
          folders[folderPath] = {
            isFolder: true,
            name: folderPath,
            isOpen: false,
            children: []
          };
          documentsTree.push(folders[folderPath]);
        }

        folders[folderPath].children.push({
          isFolder: false,
          name: fileName,
          description: document.description,
          document: document,
          isOpen: false,
          children: []
        });
      }
      else {
        documentsTree.push({
          isFolder: false,
          name: fileName,
          description: document.description,
          document: document,
          isOpen: false,
          children: []
        });
      }

    });

    //for each folder, append number of children in description
    for (const folder in folders) {
      folders[folder].description = `${folders[folder].children.length} document${folders[folder].children.length > 0 ? 's' : ''}`;
    }

    //sort the folders and files, folders first sorted by name, then files sorted by createdAt
    documentsTree.sort((a, b) => {
      if (a.isFolder && !b.isFolder) {
        return -1;
      } else if (!a.isFolder && b.isFolder) {
        return 1;
      } else if (!a.isFolder && !b.isFolder) {
        return (+b.document.createdAt - +a.document.createdAt);
      }
      else {
        return a.name.localeCompare(b.name);
      }
    });

    return documentsTree;
  }


}
